/**
 * VehicleCategories Feature Component
 * Category selector for vehicle types
 */

'use client'

import { CategoryButton } from '@/components/molecules/CategoryButton'
import { cn } from '@/lib/utils'

interface VehicleCategory {
	id: string
	label: string
	icon: React.ReactNode
}

interface VehicleCategoriesProps {
	selectedCategory: string
	onCategoryChange: (categoryId: string) => void
	className?: string
}

const categories: VehicleCategory[] = [
	{
		id: 'pickup',
		label: 'PickUp',
		icon: (
			<img
				src='/images/pickup.png'
				alt='Pickup'
				className='w-16'
			/>
		),
	},
	{
		id: 'suv',
		label: 'Suv Full Size',
		icon: (
			<img
				src='/images/suv-fullsize.png'
				alt='Suv Full Size'
				className='w-16'
			/>
		),
	},
	{
		id: 'economy',
		label: 'Económicos',
		icon: (
			<img
				src='/images/economicos.png'
				alt='Económicos'
				className='w-16'
			/>
		),
	},
	{
		id: 'compact',
		label: 'Compactos',
		icon: (
			<img
				src='/images/compactos.png'
				alt='Compactos'
				className='w-16'
			/>
		),
	},
	{
		id: 'van',
		label: 'Monovolumen\nGrande',
		icon: (
			<img
				src='/images/monovolumen.png'
				alt='Monovolumen Grande'
				className='w-16'
			/>
		),
	},
]

export function VehicleCategories({
	selectedCategory,
	onCategoryChange,
	className,
}: VehicleCategoriesProps) {
	return (
		<div className={cn('py-8 px-[3%] bg-white', className)}>
			{/* Title */}
			<h2 className='font-["Bricolage_Grotesque"] text-2xl md:text-3xl font-black text-[#09194D] text-center mb-8'>
				SELECCIONA EL VEHÍCULO PARA TÍ
			</h2>

			{/* Categories */}
			<div className='flex gap-4 overflow-x-auto pb-4 md:grid md:grid-cols-3 lg:grid-cols-5 md:overflow-visible scrollbar-hide'>
				{categories.map(category => (
					<CategoryButton
						key={category.id}
						id={category.id}
						label={category.label}
						icon={category.icon}
						isSelected={selectedCategory === category.id}
						onClick={onCategoryChange}
						className='min-w-40 md:min-w-0 shrink-0 md:shrink'
					/>
				))}
			</div>

			<div className='flex justify-center mt-6'>
				<button
					type='button'
					onClick={() => onCategoryChange('all')}
					disabled={selectedCategory === 'all'}
					className='font-["Bricolage_Grotesque"] text-lg font-bold text-[#09194D] underline underline-offset-4 decoration-[#CDFF00] hover:opacity-80 disabled:opacity-40 disabled:no-underline disabled:pointer-events-none cursor-pointer transition-opacity'
				>
					Reiniciar filtro
				</button>
			</div>
		</div>
	)
}
